/**
 * Turns an axios error into a message that actually helps diagnose it,
 * instead of a generic "failed, try again" that hides the status code and
 * whatever the backend sent back.
 */
export const describeApiError = (err, fallback) => {
  const status = err.response?.status;
  const serverMessage =
    (typeof err.response?.data === "string" && err.response.data) ||
    err.response?.data?.message;

  if (status === 403) {
    return (
      (serverMessage ? `${serverMessage} ` : "") +
      "(403 Forbidden — the backend rejected this request. Either this account doesn't have permission for it, or this endpoint isn't the right one. Check with the backend before retrying.)"
    );
  }
  if (status === 404) {
    return (
      serverMessage ||
      "(404 Not Found — this item may already be gone, or the endpoint path is wrong.)"
    );
  }
  if (serverMessage) return serverMessage;
  if (status) return `${fallback} (server responded ${status}.)`;
  return `${fallback} (no response from the server — check your connection.)`;
};
